export enum ModulePath {
  AuthenticationModule = 'auth',
  AccountModule = 'account',
  UserModule = 'users',
  UserRoleModule = 'user-roles',
  OutbreakModule = 'outbreaks',
  OutbreakTemplatesModule = 'outbreak-templates',
  ContactModule = 'contacts',
  ContactsOfContactsModule = 'contacts-of-contacts',
  CaseModule = 'cases',
  EventModule = 'events',
  LabResultModule = 'lab-results',
  DuplicateRecordsModule = 'duplicated-records',
  ClusterModule = 'clusters',
  RelationshipModule = 'relationships',
  ReferenceDataModule = 'reference-data',
  LocationModule = 'locations',
  DashboardModule = 'dashboard',
  TransmissionChainModule = 'transmission-chains',
  D3GraphsModule = 'graphs',
  ImportExportDataModule = 'import-export-data',
  SystemConfigModule = 'system-config',
  TeamModule = 'teams',
  AuditLogModule = 'audit-log',
  SavedFiltersModule = 'saved-filters',
  CloudBackupModule = 'cloud-backup',
  SavedImportMappingModule = 'saved-import-mapping',
  TermsOfUseModule = 'terms-of-use',
  VersionModule = 'version',
  LanguageModule = 'languages',
  HelpModule = 'help',
  RedirectModule = 'redirect'
}
